<template>
  <div :class="$style.container">
    <div
      :class="[$style.date, { [$style.error]: errors && errors.created_at }]"
    >
      <p>Дата {{ forCreation ? "" : "от" }}</p>
      <div :class="[$style.from]" class="from">
        <div :class="[$style.dateValue, { [$style.active]: from }]">
          <img src="/icons/picker.svg" alt="" />
          <p>
            {{
              from
                ? from.substr(0, 10).split("-").reverse().join(".")
                : "__.__.____"
            }}
          </p>
          <img @click.stop="resetDate('from')" src="/icons/cross.svg" alt="" />
        </div>

        <VueCtkDateTimePicker
          id="from"
          ref="from"
          v-model="from"
          autoClose
          locale="ru"
          formatted="DD-MM-YYYY"
          onlyDate
          inputSize="lg"
          color="#34c759"
        />
      </div>
    </div>
    <div v-if="!forCreation" :class="$style.date">
      <p>Дата до</p>
      <div :class="[$style.before, { [$style.active]: before }]" class="before">
        <div :class="[$style.dateValue, { [$style.active]: before }]">
          <img src="/icons/picker.svg" alt="" />
          <p>
            {{
              before
                ? before.substr(0, 10).split("-").reverse().join(".")
                : "__.__.____"
            }}
          </p>
          <img
            @click.stop="resetDate('before')"
            src="/icons/cross.svg"
            alt=""
          />
        </div>

        <VueCtkDateTimePicker
          id="before"
          ref="before"
          v-model="before"
          autoClose
          locale="ru"
          formatted="DD-MM-YYYY"
          onlyDate
          inputSize="lg"
          color="#34c759"
        />
      </div>
    </div>
    <div
      @mouseleave="isTypesOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.project_type },
      ]"
    >
      <p>Тип проекта</p>
      <div @mouseover="isTypesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.project_type }">{{
          selectedValues.project_type
            ? selectedValues.project_type
            : forCreation
            ? "Выберите тип"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.project_type"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('project_type', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isTypesOpen" :class="$style.options">
        <div
          v-for="i in types"
          :key="i.slug"
          @click="select('project_type', i)"
        >
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isStatusesOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.project_status },
      ]"
    >
      <p>Статус проекта</p>
      <div @mouseover="isStatusesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.project_status }">{{
          selectedValues.project_status
            ? selectedValues.project_status
            : forCreation
            ? "Выберите статус"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.project_status"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('project_status', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isStatusesOpen" :class="$style.options">
        <div
          v-for="i in statuses"
          :key="i.slug"
          @click="select('project_status', i)"
        >
          <div :class="[$style.dot, $style[i.color]]"></div>
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isChannelsOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.attraction_channel },
      ]"
    >
      <p>Канал привлечения</p>
      <div @mouseover="isChannelsOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.attraction_channel }">
          {{
            selectedValues.attraction_channel
              ? selectedValues.attraction_channel
              : forCreation
              ? "Выберите канал"
              : "Все"
          }}</span
        >
        <img
          v-if="!selectedValues.attraction_channel"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('attraction_channel', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isChannelsOpen" :class="$style.options">
        <div
          v-for="i in channels"
          :key="i.slug"
          @click="select('attraction_channel', i)"
        >
          <img :src="i.icon" alt="" />
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isPaymentsOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.payment_type },
      ]"
    >
      <p>Тип расчета</p>
      <div @mouseover="isPaymentsOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.payment_type }">{{
          selectedValues.payment_type
            ? selectedValues.payment_type
            : forCreation
            ? "Выберите тип"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.payment_type"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('payment_type', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isPaymentsOpen" :class="$style.options">
        <div
          v-for="i in payments"
          :key="i.slug"
          @click="select('payment_type', i)"
        >
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isLeadsOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.lead_qualification },
      ]"
    >
      <p>Квалифик. лида</p>
      <div @mouseover="isLeadsOpen = true" :class="$style.select">
        <span
          :class="{ [$style.selected]: selectedValues.lead_qualification }"
          >{{
            selectedValues.lead_qualification
              ? selectedValues.lead_qualification
              : forCreation
              ? "Выберите тип"
              : "Все"
          }}</span
        >
        <img
          v-if="!selectedValues.lead_qualification"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('lead_qualification', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isLeadsOpen" :class="$style.options">
        <div
          v-for="i in leads"
          :key="i.slug"
          @click="select('lead_qualification', i)"
        >
          {{ i.title }}
        </div>
      </div>
    </div>
    <div v-if="!forCreation" @click="reset" :class="$style.reset">Сбросить</div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import FILTERS from "@/assets/constants/filters.json";
export default {
  data() {
    return {
      types: FILTERS.types,
      statuses: FILTERS.statuses,
      channels: FILTERS.channels,
      payments: FILTERS.payments,
      leads: FILTERS.leads,
      isTypesOpen: false,
      isStatusesOpen: false,
      isChannelsOpen: false,
      isPaymentsOpen: false,
      isLeadsOpen: false,
      selectedValues: {
        project_type: "",
        project_status: "",
        attraction_channel: "",
        payment_type: "",
      },
      filters: {
        project_type: "",
        project_status: "",
        attraction_channel: "",
        payment_type: "",
        lead_qualification: "",
        from: "",
        before: "",
      },
      from: "",
      before: "",
      isLoad: false,
      errors: [],
      interval: "",
    };
  },
  components: {
    VueCtkDateTimePicker,
  },
  props: {
    forCreation: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    this.interval = setInterval(() => {
      this.filters.isNotLoad = true;
      this.$store.dispatch("getLeads", this.filters);
      this.filters.isNotLoad = false;
    }, 30000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    select(field, value) {
      if (value) {
        this.selectedValues[field] = value.title;
        this.filters[field] = value.slug;
        this.$store.commit("setLeadsField", { field, value: value.slug });
      } else {
        this.selectedValues[field] = "";
        this.filters[field] = "";
        this.$store.commit("setLeadsField", { field, value: "" });
      }
      if (this.$route.fullPath === "/leads") {
        this.getData();
      }
    },
    reset() {
      for (let key in this.selectedValues) {
        this.selectedValues[key] = "";
      }
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.from = "";
      this.before = "";
      this.getData();
    },
    resetDate(key) {
      this.filters[key] = "";
      key === "from" ? (this.from = "") : (this.before = "");
      this.getData();
    },
    async getData() {
      this.$store.dispatch("getLeads", this.filters);
    },
  },
  computed: {
    lead() {
      return this.$store.state.leads.lead;
    },
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
  watch: {
    from() {
      this.from
        ? (this.filters.from = this.from.substr(0, 10))
        : (this.from = null);
      if (this.$route.fullPath === "/leads") {
        this.getData();
      } else {
        this.$store.commit("setLeadsField", {
          field: "created_at",
          value: this.from.substr(0, 10),
        });
      }
    },
    before() {
      this.filters.before = this.before.substr(0, 10);
      if (this.$route.fullPath === "/leads") {
        this.getData();
      }
    },
    lead() {
      if (!this.isLoad) {
        if (this.lead.id) {
          this.selectedValues = {
            project_type: this.lead.project_type
              ? this.types.find((i) => i.slug === this.lead.project_type).title
              : "",
            project_status: this.statuses.find(
              (i) => i.slug === this.lead.project_status
            ).title,
            attraction_channel: this.channels.find(
              (i) => i.slug === this.lead.attraction_channel
            ).title,
            payment_type: this.payments.find(
              (i) => i.slug === this.lead.payment_type
            ).title,
            lead_qualification: this.lead.lead_qualification
              ? this.leads.find((i) => i.slug === this.lead.lead_qualification)
                  .title
              : "",
          };
          this.from = this.lead.created_at.substr(0, 10);
        }
        this.isLoad = true;
      }
    },
    allErrors() {
      this.errors = this.allErrors;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  > div {
    width: 100%;
    p {
      @include Body3;
      color: $t-secondary;
      margin: 0 0 0.25rem 0;
    }
  }
  .date {
    .from,
    .before {
      position: relative;
      .dateValue {
        height: 2.5rem;
        @include Subtitle;
        color: $t-secondary;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid $bg-separator;
        gap: 0.5rem;
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        cursor: pointer;
        p {
          flex: 1 1 auto;
          position: relative;
          top: 0.2rem;
        }
        img {
          position: relative;
          z-index: 2;
        }
        &.active {
          p {
            color: $t-primary;
            @include Subtitle;
          }
        }
      }

      input {
        opacity: 0;
      }
      label {
        display: none;
      }
    }
    &.error {
      p {
        color: $red;
      }
      .from {
        .dateValue {
          border: 1px solid $red;
        }
      }
    }
  }
  .filter {
    position: relative;
    .select {
      padding: 0.75rem;
      @include Subtitle;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      cursor: pointer;
      span.selected {
        color: $t-primary;
      }
    }
    .options {
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      position: absolute;
      z-index: 2;
      background-color: $bg-secondary;
      border-bottom: none;
      width: 100%;
      cursor: pointer;
      > div {
        color: $t-secondary;
        @include Subtitle;
        padding: 0.5rem;
        border-bottom: 1px solid $bg-separator;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .dot {
          width: 0.5rem;
          height: 0.5rem;
          flex: 0 0 0.5rem;
          border-radius: 50%;
          &.orange {
            background-color: $orange;
          }
          &.grey {
            background-color: $t-secondary;
          }
          &.green {
            background-color: $main-green;
          }
          &.purple {
            background-color: $purple;
          }
          &.blue {
            background-color: $blue-primary;
          }
          &.red {
            background-color: $red-primary;
          }
        }
      }
    }
    &.error {
      > p {
        color: $red;
      }
      .select {
        border: 1px solid $red;
      }
    }
  }

  .reset {
    background-color: $main-green;
    padding: 0.75rem 0;
    @include Body2;
    border-radius: 0.25rem;
    text-align: center;
    color: $t-white;
  }
}
</style>

<style lang="scss">
.date-time-picker {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.5rem;
  width: 100%;
}
.fs-16 {
  display: none;
}
.custom-button {
  display: none;
}
.datepicker-button-content {
  color: $main-green !important;
}
</style>
